import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { AppearanceService } from '../../services/appearance/appearance.service';
import { Constants } from 'src/app/constants/constants';

@Component({
  selector: 'app-modal-view-image',
  templateUrl: './modal-view-image.component.html',
  styleUrls: ['./modal-view-image.component.scss'],
})
export class ModalViewImageComponent  implements OnInit {

  base64Image = null;

  constructor(private modalController: ModalController, public appearanceService: AppearanceService) { }

  ngOnInit() {}

  ionViewWillEnter()
  {    
    if(!this.base64Image)
    {
      this.appearanceService.presentToast("Something went wrong. No image to display", Constants.TOAST_ERROR);
    }
  }

  closeModal(returnData = null)
  {
    this.modalController.dismiss(returnData, null, 'ImageModal');
  }
}
